import Client from 'shopify-buy';
import { contentAPI } from '../config';
import { urlify } from '../utils/string';

export const RETRIEVED = 'RETRIEVED';
export const GET_PAGE = 'GET_PAGE';
export const GET_NAVIGATION = 'GET_NAVIGATION';
export const GET_PRODUCT_LIST = 'GET_PRODUCT_LIST';
export const GET_PRODUCT = 'GET_PRODUCT';
export const SET_QUERY = 'SET_QUERY';

export const GET_SHOPIFY_CLIENT = 'GET_SHOPIFY_CLIENT';
export const GET_SHOPIFY_PRODUCT_LIST = 'GET_SHOPIFY_PRODUCT_LIST';
export const GET_SHOP_INFO = 'GET_SHOP_INFO';
export const GET_SHOPIFY_CART = 'GET_SHOPIFY_CART';
export const ADD_TO_BAG = 'ADD_TO_BAG';
export const SHOW_BAG_POPUP = 'SHOW_BAG_POPUP';
export const HIDE_BAG_POPUP = 'HIDE_BAG_POPUP';
export const UPDATE_BAG = 'UPDATE_BAG';

export const SLIDE_PRODUCT_IMAGE = 'SLIDE_PRODUCT_IMAGE';
export const FILTER_PRODUCTS = 'FILTER_PRODUCTS';
export const TOGGLE_PRODUCT_PROPERTY = 'TOGGLE_PRODUCT_PROPERTY';
export const CHANGE_SLIDE = 'CHANGE_SLIDE';
export const WINDOW_DIMENSIONS = 'WINDOW_DIMENSIONS';
export const TOGGLE_PRODUCT_HOVER = 'TOGGLE_PRODUCT_HOVER';
export const PREVIOUS_PAGE = 'PREVIOUS_PAGE';

/*
	API CONNECTION
*/

const haveAlreadyRetrieved = (route, dispatch, getState) => {
	const retrieved = getState().environment.retrieved;
	if (retrieved.indexOf(route) === -1) {
		dispatch({ type: RETRIEVED, route });
		return false;
	}
	return true;
};

const getFetchOptions = (getState) => {
	const previewCode = getState().environment.setup.preview || (typeof window !== 'undefined' ? localStorage.getItem('preview') : false);
	const fetchOptions = {
		method: 'GET',
		mode: 'cors',
		cache: 'no-cache',
	};

	if (previewCode) {
		fetchOptions.method = 'POST';
		fetchOptions.accept = 'application/json, text/plain, */*;';
		fetchOptions.body = JSON.stringify({ previewCode });
	}

	return fetchOptions;
};

export const addQuery = (query) => {
	localStorage.setItem('preview', query);
	return { type: SET_QUERY, query };
};

export const getPage = route => (dispatch, getState) => {
	if (haveAlreadyRetrieved((route === '' ? 'start' : route), dispatch, getState)) return false;

	return fetch(`${contentAPI}${route}${(route === '' ? '' : '/')}`, getFetchOptions(getState))
		.then(response => response.json())
		.then(data => dispatch({ type: GET_PAGE, data, page: (route === '' ? 'start' : route) }))
		.catch((err) => {
			console.warn(`ERROR: unable to retrieve route ${route}`, err);
			return false;
		});
};

export const getProduct = route => (dispatch, getState) => {
	if (haveAlreadyRetrieved(route, dispatch, getState)) return false;

	return fetch(`${contentAPI}product/${route}`, getFetchOptions(getState))
		.then(response => response.json())
		.then((data) => {
			if (data.content.product !== undefined) {
				return dispatch({ type: GET_PRODUCT, data });
			}
			return false;
		})
		.catch((err) => {
			console.warn('ERROR: unable to retrieve product ', err);
			return false;
		});
};

export const getProductList = () => (dispatch, getState) => {
	const route = 'products';
	if (haveAlreadyRetrieved(route, dispatch, getState)) return false;

	return fetch(`${contentAPI}${route}`, getFetchOptions(getState))
		.then(response => response.json())
		.then(data => dispatch({ type: GET_PRODUCT_LIST, data }))
		.catch((err) => {
			console.warn('ERROR: unable to retrieve product listing ', err);
			return false;
		});
};

export const getNavigation = () => (dispatch, getState) => {
	const route = 'init';
	if (haveAlreadyRetrieved(route, dispatch, getState)) return false;

	return fetch(`${contentAPI}${route}`, getFetchOptions(getState))
		.then(response => response.json())
		.then(data => dispatch({ type: GET_NAVIGATION, data }))
		.catch((err) => {
			console.warn('ERROR: unable to initialize data ', err);
			return false;
		});
};


/*
	ECOMMERCE
*/

let showPopupTimeout;

const getItems = (lineItems) => {
	const items = {};

	lineItems.forEach((item) => {
		const id = window.atob(item.variant.id);
		items[id.slice(id.lastIndexOf('/') + 1)] = {
			quantity: item.quantity,
			lineItem: item.id,
		};
	});

	return items;
};

export const getShopifyClient = () => (dispatch, getState) => {
	const { shopName, api } = getState().environment.setup.keys;
	if (!shopName || !api) return dispatch({ type: GET_SHOPIFY_CLIENT, client: false });

	const config = {
		domain: `${shopName}.myshopify.com`,
		storefrontAccessToken: api,
	};

	const client = Client.buildClient(config);
	const shopifyID = localStorage.getItem('shopifyID');

	client.shop.fetchInfo()
		.then(shop => dispatch({ type: GET_SHOP_INFO, shop }))
		.catch((err) => { console.log('DEBUG: unable to get shop info ', err); });

	if (shopifyID !== null) {
		client.checkout.fetch(shopifyID)
			.then((cart) => {
				if (cart.orderStatusUrl !== null) {
					localStorage.removeItem('shopifyID');
					return false;
				}
				return dispatch({ type: GET_SHOPIFY_CART, cart, items: getItems(cart.lineItems), checkoutID: shopifyID });
			})
			.catch((err) => { console.log('DEBUG: unable to get cart ', err); });
	}

	client.product.fetchAll().then((products) => {
		const shopifyProducts = {};

		products.forEach((product) => {
			product.attrs.variants.forEach((variant) => {
				const id = window.atob(variant.id);
				shopifyProducts[id.slice(id.lastIndexOf('/') + 1)] = {
					availability: variant.available,
					price: parseFloat(variant.price),
				};
			});
		});

		return dispatch({ type: GET_SHOPIFY_PRODUCT_LIST, products: shopifyProducts });
	}).catch(err => console.log('DEBUG: Could not retrieve products', err));

	return dispatch({ type: GET_SHOPIFY_CLIENT, client });
};

export const addToBag = id => (dispatch, getState) => {
	if (typeof window !== 'undefined') {
		const shop = getState().environment.shop;
		const addItems = [
			{ variantId: window.btoa(`gid://shopify/ProductVariant/${id}`), quantity: 1 },
		];

		if (!shop.checkout.ID) {
			shop.shopify.checkout.create()
				.then(checkout => shop.shopify.checkout.addLineItems(checkout.id, addItems))
				.then((checkout) => {
					localStorage.setItem('shopifyID', checkout.id);
					window.clearTimeout(showPopupTimeout);
					showPopupTimeout = window.setTimeout(() => { dispatch({ type: HIDE_BAG_POPUP }); }, 3000);
					return dispatch({ type: ADD_TO_BAG, checkoutID: checkout.id, cart: checkout, location: checkout.webUrl, items: getItems(checkout.lineItems) });
				})
				.catch(err => console.log('DEBUG: could not create checkout and add item ', err));
		} else {
			shop.shopify.checkout.addLineItems(shop.checkout.ID, addItems)
				.then((checkout) => {
					window.clearTimeout(showPopupTimeout);
					showPopupTimeout = window.setTimeout(() => { dispatch({ type: HIDE_BAG_POPUP }); }, 3000);
					return dispatch({ type: ADD_TO_BAG, checkoutID: checkout.id, cart: checkout, location: checkout.webUrl, items: getItems(checkout.lineItems) });
				})
				.catch(err => console.log('DEBUG: could not add item to checkout ', err));
		}
	}
};

export const showBagPopup = () => ({ type: SHOW_BAG_POPUP });

export const adjustItem = (id, method) => (dispatch, getState) => {
	if (typeof window !== 'undefined') {
		const shop = getState().environment.shop;
		const item = shop.checkout.items[id];
		const quantity = item.quantity;

		if (method === 'increaseItem') {
			const increaseItems = {
				id: item.lineItem,
				quantity: quantity + 1,
				variantId: window.btoa(`gid://shopify/ProductVariant/${id}`),
			};

			shop.shopify.checkout.updateLineItems(shop.checkout.ID, increaseItems)
				.then(checkout => dispatch({ type: UPDATE_BAG, cart: checkout, items: getItems(checkout.lineItems) }))
				.catch(err => console.log('DEBUG: could not remove item from checkout ', err));
		} else if (method === 'decreaseItem' && quantity > 1) {
			const decreaseItems = {
				id: item.lineItem,
				quantity: quantity - 1,
				variantId: window.btoa(`gid://shopify/ProductVariant/${id}`),
			};

			shop.shopify.checkout.updateLineItems(shop.checkout.ID, decreaseItems)
				.then(checkout => dispatch({ type: UPDATE_BAG, cart: checkout, items: getItems(checkout.lineItems) }))
				.catch(err => console.log('DEBUG: could not remove item from checkout ', err));
		} else if (method === 'removeItem' || (method === 'decreaseItem' && quantity === 1)) {
			const removeItems = [item.lineItem];

			shop.shopify.checkout.removeLineItems(shop.checkout.ID, removeItems)
				.then(checkout => dispatch({ type: UPDATE_BAG, cart: checkout, items: getItems(checkout.lineItems) }))
				.catch(err => console.log('DEBUG: could not remove item from checkout ', err));
		}
	}
};


/*
	PAGE INTERACTIONS
*/

export const slideProductImage = (uri, direction, index = false) => (dispatch, getState) => {
	const productData = getState().environment.products[uri];
	const numberImages = productData.product.images.length;


	if (index === false) {
		let nextIndex = (productData.slideIndex + direction) % numberImages;
		if (nextIndex < 0) nextIndex = numberImages - nextIndex - 2;
		return dispatch({ type: SLIDE_PRODUCT_IMAGE, uri, index: nextIndex });
	}

	if (index > productData.slideIndex) {
		const loopMove = (nextIndex, currentIndex) => {
			if (nextIndex > currentIndex) {
				dispatch({ type: SLIDE_PRODUCT_IMAGE, uri, index: currentIndex + 1 });
				currentIndex += 1;
				setTimeout(() => {
					loopMove(nextIndex, currentIndex);
				}, 300);
			}
		};

		loopMove(index, productData.slideIndex);
	} else if (index < productData.slideIndex) {
		const loopMove = (nextIndex, currentIndex) => {
			if (nextIndex < currentIndex) {
				dispatch({ type: SLIDE_PRODUCT_IMAGE, uri, index: currentIndex - 1 });
				currentIndex -= 1;
				setTimeout(() => {
					loopMove(nextIndex, currentIndex);
				}, 300);
			}
		};

		loopMove(index, productData.slideIndex);
	}
};

export const updatePreviousPage = page => ({ type: PREVIOUS_PAGE, page });

export const filterProducts = (filter, toggleSideSubMenu) => (dispatch, getState) => {
	const allProducts = getState().environment.productList.products;
	const products = {};

	Object.keys(allProducts).forEach((key) => {
		if (urlify(allProducts[key].productName) === filter || filter === '') {
			products[key] = { ...allProducts[key] };
		}
	});

	return dispatch({ type: FILTER_PRODUCTS, filter, products });
};

export const hoverProducts = id => (dispatch) => {
	window.setTimeout(() => { dispatch({ type: TOGGLE_PRODUCT_HOVER, id }); }, 800);
	return dispatch({ type: TOGGLE_PRODUCT_HOVER, id });
};

export const toggleProductProperty = (uri, property) => ({ type: TOGGLE_PRODUCT_PROPERTY, uri, property });

export const changeSlide = contentKey => ({ type: CHANGE_SLIDE, contentKey });

export const windowDimensions = (width, height) => ({ type: WINDOW_DIMENSIONS, width, height });



// WEBPACK FOOTER //
// ./actions/environment.js